import React, {useEffect, useState} from "react"
import "./SeatsPickerInitiator.scss"
import {usePickerContext} from "../hooks/usePickerContext"
import {usePickerCore} from "../hooks/usePickerCore"
import {SeatsPicker} from "./SeatsPicker"
import {Style} from "../../../core/Style"
import {LoaderFullScreen} from "./Loader"
import {SeatsPickerInitiator} from "./SeatsPickerInitiator"
import {SeatsPickerModal} from "./SeatsPickerModal"
import { useResponsiveMarkers } from "../hooks/useResponsiveMarkers"

export function SeatsPickerContainer(props) {

    const {state, dispatch} = usePickerContext()
    const {getConfiguration, getDates, getSteps} = usePickerCore()
    const {loading, isInitLoaded} = state
    const [showPicker, setShowPicker] = useState(false)
    useResponsiveMarkers();

    const onInit = () => {
        getConfiguration()
    }

    const onInitLoaded = () => {
        if (!state.isConfigurationLoaded) return
        if (state.typeWidget === "FREE") {
            getDates()
        }
        if (state.typeWidget === "PASS") {
            getSteps()
        }
        Style.applyVariables(props.parent, state.styles.variables)
    }

    const onFullyLoaded = () => {
        if (!state.isInitLoaded) return
        props.parent.addEventListener("open", () => {
            setShowPicker(true)
        })
        props.parent.addEventListener("close", () => {
            setShowPicker(false)
        })
        props.parent.addEventListener("selectDate", ({detail: {value, hour}}) => {
            dispatch({type: "SET_CURRENT_DATE", payload: {at: value, hour}})
        })
        if (state.onInitialized) state.onInitialized()
    }

    useEffect(onInit, [])
    useEffect(onInitLoaded, [state.isConfigurationLoaded])
    useEffect(onFullyLoaded, [state.isInitLoaded])

    return (
        <>
            {loading &&
            <SeatsPickerModal>
                <LoaderFullScreen/>
            </SeatsPickerModal>
            }
            {props.showSearchForm &&
            <SeatsPickerInitiator
                onSearch={() => setShowPicker(true)}
            />
            }
            {showPicker && isInitLoaded &&
            <SeatsPickerModal>
                <SeatsPicker
                    onClose={e => {
                        if (state.onExitClicked) state.onExitClicked()
                        setShowPicker(false)
                    }}
                    showDateSelector={props.showDateSelector}
                />
            </SeatsPickerModal>
            }
        </>
    )
}